import { useQuery } from "@tanstack/react-query"
import { shopifyOrderTagsQuery } from "modules/settings/lib/shopify/shopifyOrderTagsQuery"

export const useShopifyOrderTagsQuery = (enabled: boolean) =>
  useQuery({ ...shopifyOrderTagsQuery(), enabled })
